module.exports = __webpack_public_path__ + "static/media/lunbo8.9d8eb193.png";